// Portal pages render on the server in UTC and hydrate in the visitor's own
// timezone, so a locally formatted date tears the tree apart on every non-UTC visit
const FULL = new Intl.DateTimeFormat("en-US", {
	timeZone: "UTC",
	month: "short",
	day: "2-digit",
	year: "numeric",
})

const DAY_MONTH = new Intl.DateTimeFormat("en-US", {
	timeZone: "UTC",
	month: "short",
	day: "numeric",
})

const toDate = (value: Date | string | number): Date | null => {
	const date = value instanceof Date ? value : new Date(value)
	return Number.isNaN(date.getTime()) ? null : date
}

export function formatPortalDate(value: Date | string | number): string {
	const date = toDate(value)
	return date ? FULL.format(date) : ""
}

export function formatPortalDayMonth(value: Date | string | number): string {
	const date = toDate(value)
	return date ? DAY_MONTH.format(date) : ""
}
